import React from 'react';
import { Link } from 'react-router-dom';

export default function TestimonialsPage() {
  return (
    <>
      <title>Klienthistorier | rolskov-bowtech.dk</title>
      <meta
        name="description"
        content="Klienthistorier og erfaringer med Bowtech-behandling hos Jørn Rolskov i Skårup på Fyn."
      />
      <link rel="canonical" href="https://rolskov-bowtech.dk/Klienthistorier" />

      {/* Header Banner */}
      <section className="bg-[#f4efe6]/60 py-12 lg:py-16 border-b border-[#228A47]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4">
          <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider bg-[#e8f5ed] px-3 py-1 rounded-full">
            Erfaringer &amp; Udtalelser
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#062364]">
            Klienthistorier
          </h1>
          <p className="text-base sm:text-lg text-[#132038] max-w-3xl leading-relaxed">
            Læs personlige fortællinger fra klienter, der har modtaget Bowtech-behandling hos Jørn Rolskov.
          </p>
        </div>
      </section>

      {/* Main Story Content */}
      <section className="py-16 bg-[#faf8f5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="bg-white rounded-3xl p-8 lg:p-12 border border-[#228A47]/15 shadow-sm space-y-8 relative overflow-hidden">
            <div className="absolute top-0 right-0 p-8 text-[#e8f5ed] pointer-events-none opacity-50">
              <i className="fa-solid fa-quote-right text-8xl" aria-hidden="true"></i>
            </div>

            <div className="space-y-2 relative z-10">
              <span className="text-xs font-semibold text-[#228A47] uppercase tracking-wider bg-[#e8f5ed] px-3 py-1 rounded-md">
                Rygsmerter / Eliteidræt
              </span>
              <h2 className="text-2xl sm:text-3xl font-bold text-[#062364]">
                En forandring for livet!
              </h2>
            </div>

            <div className="text-base text-[#132038] leading-relaxed space-y-4 font-normal relative z-10 border-l-2 border-[#228A47] pl-6">
              <p>
                Jeg er i dag 35 år og har dyrket eliteidræt siden jeg var 17 år gammel. Da jeg var i starten af 20’erne begyndte jeg at få ondt i min ryg, som trak ned venstre ben. Da det var værst, var jeg meget tæt på at stoppe min idræt, da smerterne var for store. Siden lærte jeg at leve med kroniske smerter og kompensere.
              </p>
              <p>
                I mit behandlingsforløb har jeg været omkring fysioterapeuter, kiropraktorer, massører, læger og bl.a. herunder en MR-scanning. Ingen har kunnet fortælle mig, hvad der var galt andet end, at min træning var for hård for kroppen, og jeg burde stoppe.
              </p>
              <p>
                Da jeg marts 2016 kom i kontakt med Jørn omkring en behandling, var jeg derfor meget spændt for ingen har kunnet afhjælpe mine problemer igennem 15 år. Efter 2 minutters undersøgelse havde Jørn et bud på, hvorfor jeg havde ondt – min hofte var skæv – meget skæv! INGEN havde sagt det før. Igennem tre behandlinger blev det justeret, og jeg har i dag et halvt år senere bogstavlig talt ingen smerter! Mine varmeste anbefalinger går til Jørn, hvis du har ubalance i din krop.
              </p>
            </div>

            <div className="pt-4 border-t border-[#f4efe6] flex items-center justify-between relative z-10">
              <div>
                <p className="text-lg font-bold text-[#062364]">Thomas Jessen</p>
                <p className="text-xs font-semibold text-[#228A47]">Svendborg</p>
              </div>
              <div className="flex items-center gap-1 text-[#d9a036] text-sm">
                <i className="fa-solid fa-star" aria-hidden="true"></i>
                <i className="fa-solid fa-star" aria-hidden="true"></i>
                <i className="fa-solid fa-star" aria-hidden="true"></i>
                <i className="fa-solid fa-star" aria-hidden="true"></i>
                <i className="fa-solid fa-star" aria-hidden="true"></i>
              </div>
            </div>

          </div>

          {/* Contact Prompt */}
          <div className="bg-[#062364] text-white p-8 rounded-3xl text-center space-y-4">
            <h3 className="text-2xl font-bold">Har du lignende problemer eller skader?</h3>
            <p className="text-sm text-slate-200 max-w-xl mx-auto">
              Kontakt Jørn for at høre, om Bowtech kan gøre en forskel for dig.
            </p>
            <div className="pt-2 flex flex-wrap justify-center gap-4">
              <a
                href="tel:27117557"
                className="whitespace-nowrap px-6 py-3 text-sm font-semibold text-white bg-[#228A47] hover:bg-[#1b713a] rounded-xl transition-colors"
              >
                Ring på 27 11 75 57
              </a>
              <Link
                to="/contact"
                className="px-6 py-3 text-sm font-semibold text-white bg-white/10 hover:bg-white/20 rounded-xl transition-colors"
              >
                Send en besked
              </Link>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
